<div class="accordion mb-5">
  @if (!isAbgelaufen()) {
    <div class="card">
      <div class="card-body text-center">
        <h1 class="card-title">
          {{ header() }}
          {{ parameterService.getOpenAmount() | currency : 'EUR' : 'symbol' }}
        </h1>
        
        <div class="subline">
          @if (headerLine1()) 
          {
            <div class="headerline headerline1" [innerHTML]="headerLine1()"></div>
          }
          <app-countdown (ablaufenEvent)="setAbgelaufen()" />
          @if (headerLine2()) 
          {
            <div class="headerline headerline2" [innerHTML]="headerLine2()"></div>
          }
        </div>

      </div>
      <div class="list-group list-group-flush">
        <div class="list-group-item text-center">
          <h2>{{ parameterService.channel?.title }}</h2>
          <button class="btn btn-link" (click)="toogle_show_details()">
            {{ mehrTextCalculated() }}
          </button>
        </div>

        @if (show_details) {
          <app-choosepayment-paymentoverview />
        }

        <app-choosepayment-coupon-cashing />

        <div
          class="list-group-item list-group-item-warning text-center"
          *ngIf="error * 1 === 1"
        >
          <h5>
            Beim Bezahlen ging was schief? Kein Problem! Erneut versuchen oder
            anderen Zahlungsanbieter wählen!
          </h5>
        </div>
      </div>
    </div>

    @for (paymentprovider of parameterService.list; track paymentprovider.id) {
      <app-choosepayment-paymentprovider
        [paymentprovider]="paymentprovider"
        [openPaymentproviderId]="openPaymentproviderId"
        (togglePaymentProvider)="togglePaymentprovider($event)"
      />
    } 
  } 
  @else {
    <div class="card">
      <div class="card-body text-center">
        <h1>Zeitraum abgelaufen</h1>
      </div>
    </div>
  }
</div>
